import React from 'react';

const PaginaTion = ({ currentPage, lastPage, onPageChange }) => {
  if (lastPage <= 1) return null;

  const pages = [];

  for (let i = 1; i <= lastPage; i++) {
    pages.push(i);
  }

  const handleClick = (e, page) => {
    e.preventDefault();
    if (page >= 1 && page <= lastPage && page !== currentPage) {
      onPageChange(page);
    }
  };

  return (
    <div className="paginations">
      <ul className="lab-ul d-flex flex-wrap justify-content-center mb-1">
        <li>
          <a
            href="#"
            onClick={(e) => handleClick(e, currentPage - 1)}
            className={currentPage === 1 ? 'disabled' : ''}
          >
            <i className="icofont-rounded-double-left"></i>
          </a>
        </li>

        {pages.map((page) => (
          <li
            key={page}
            className={`${
              (page !== 1 && page !== lastPage && Math.abs(page - currentPage) > 1)
                ? 'd-none d-sm-block'
                : ''
            }`}
          >
            <a
              href="#"
              onClick={(e) => handleClick(e, page)}
              className={page === currentPage ? 'active' : ''}
            >
              {page}
            </a>
          </li>
        ))}

        <li>
          <a
            href="#"
            onClick={(e) => handleClick(e, currentPage + 1)}
            className={currentPage === lastPage ? 'disabled' : ''}
          >
            <i className="icofont-rounded-double-right"></i>
          </a>
        </li>
      </ul>
    </div>
  );
};

export default PaginaTion;
